var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:`completeModal${_vm.announcement.id}`,attrs:{"id":_vm.id,"ok-only":true},on:{"hide":_vm.handleOkButtonClick}},[_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.announcement.content),expression:"announcement.content"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }